import request from "../../../utilities/requests";
import { clearWalkUpContext } from "../../../utilities/walkup";

const buildDescriptor = ({ eventId, token, response }) => ({
  source: "walkup",
  completion: "checkin",
  eventId: String(eventId),
  token,
  eventName: response?.eventName || "",
  status: response?.eventStatus || null,
  photoRequired: !!response?.photoRequired,
  checkInDisabled: !!response?.checkInDisabled,
  questionGroupId: response?.checkIn?.questionGroupId || null,
  questionGroupName: response?.checkIn?.questionGroup || null,
  eventPage: "mixer",
});

const walkUpSource = {
  key: "walkup",
  buildDescriptor,

  refresh: async (descriptor) => {
    const result = await request(
      `events/walkup/status?eventId=${descriptor.eventId}&token=${descriptor.token}`
    );
    if (!result.success || !result.valid) return null;
    return buildDescriptor({
      eventId: descriptor.eventId,
      token: descriptor.token,
      response: result,
    });
  },

  onComplete: () => {
    clearWalkUpContext();
  },
};

export default walkUpSource;
